export default __webpack_public_path__ + "static/media/truck-icon-white.329e26ed.svg";